/**
 * First checks the window (public/index.html file) for the key. If the key isn't
 * a configuration token return it. Otherwise, check process.env (.env file) and
 * return that value
 * @param key 
 * @returns 
 */
const getConfigValue = (key: string) => {
  var hostname = window.location.hostname
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '') {
    return process.env[`${"REACT_APP_"}${key}`];
  }
  return (window as any)[key];
}

/**
 * Object with the WebClient's configuration values
 * First checks the window (public/index.html file) for the key. If the key isn't
 * a configuration token return it. Otherwise, check process.env (.env file) and
 * return that value
 */
export const config = {
  apiUrl: getConfigValue("apiUrl"),
  version: getConfigValue("version"),
  oidcAuthority: getConfigValue("oidcAuthority"),
  oidcClientId: getConfigValue("oidcClientId"),
  oidcResponseType: getConfigValue("oidcResponseType"),
  oidcScope: getConfigValue("oidcScope"),
  oidcClientTsDebugLog: getConfigValue("oidcClientTsDebugLog"),
  recaptchaSiteKey: getConfigValue("recaptchaSiteKey")
}